import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

/**
 *
 * @returns {Promise<object[]>}
 */

export const crearRestriccion = async (restriccion) => {
    try {
        const resp = await axios.post(
            `${API_URL}/restricciones`,
            restriccion,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};

